import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
// import {Draggable, Dropcontainer, Eventcalendar} from "@mobiscroll/react";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Calendar} from "primereact/calendar";
import {addLocale} from "primereact/api";
import axios from "axios";
import moment from "moment/moment";

const ScheduleitemMachinecycleCalendarComponent = (props) => {

  const {t} = props;
  const getMondayOfCurrentWeek = (date) => {
    const now = new Date(date);
    const day = now.getDay(); // 0 (vasárnap), 1 (hétfő), ... 6 (szombat)
    const diff = day === 0 ? -6 : 1 - day; // Ha vasárnap, akkor 6 napot vissza; egyébként a hétfőig állít
    return new Date(now.setDate(now.getDate() + diff));
  };
  const [selectedDate, setSelectedDate] = useState(getMondayOfCurrentWeek(Date.now()));
  const [tasks, setTasks] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [scheduleItems, setScheduleItems] = useState([]);
  const [dialogQuantity, setDialogQuantity] = useState(false);
  const [jobData, setJobData] = useState({});

  // const Task = ({data}) => {
  //   const [draggable, setDraggable] = useState();
  //   return (
  //     <>
  //       {data.sub_task ? (
  //         <div className={"p-col-12 p-md-3 p-col-align-center p-p-1"}>
  //           {!data.hide && (
  //             <div ref={setDraggable} className="external-drop-task subtask" style={{background: data.color}}>
  //               <div className={"p-grid p-m-0 p-p-0"}>
  //                 <div className={"p-col-12 p-col-align-center p-text-center"}>
  //                   <h4 className={"p-m-0 p-p-0"}>
  //                     {data.quantity || "0"} db
  //                   </h4>
  //                 </div>
  //               </div>
  //               <Draggable dragData={data} element={draggable}/>
  //             </div>
  //           )}
  //         </div>
  //       ) : (
  //         <div className={"p-col-12 p-md-12 p-col-align-center p-p-1"}>
  //           {!data.hide && (
  //             <div ref={setDraggable} className="external-drop-task" style={{background: data.color}}>
  //               <div className={"p-grid p-m-0 p-p-0"}>
  //                 <div className={"p-col-12 p-md-8 p-col-align-center"}>
  //                   <span className={"p-d-block p-text-bold"}>{data.technology_name}</span>
  //                   <span className={"p-d-block"}>{data.container}, {data.partner_name || 'Ismeretlen partner'}</span>
  //                 </div>
  //                 <div className={"p-col-12 p-md-4 p-col-align-center p-text-right"}>
  //                   <h3 className={"p-m-0 p-p-0"}>
  //                     {data.quantity || "0"} db
  //                   </h3>
  //                 </div>
  //               </div>
  //               <Draggable dragData={data} element={draggable}/>
  //             </div>
  //           )
  //           }
  //         </div>
  //       )}
  //     </>
  //   )
  // }

  addLocale('default', {
    firstDayOfWeek: 1,
    dayNames: [t('sunday'), t('monday'), t('tuesday'), t('wednesday'), t('thursday'), t('friday'), t('saturday')],
    dayNamesShort: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    dayNamesMin: [t('sun'), t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat')],
    monthNames: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    monthNamesShort: [t('jan'), t('feb'), t('mar'), t('apr'), t('may'), t('jun'), t('jul'), t('aug'), t('sep'),
      t('oct'), t('nov'), t('dec')],
    today: t('today'),
    clear: t('delete')
  });

  useEffect(() => {
    setTasks([])
    setLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/schedule-item-calendar?search[schedule_group]="
      + window.App.state.selectedScheduleGroup.id + "&search[from]="
      + moment.utc(selectedDate).local().format('YYYY-MM-DD') + "T00:00:00&search[to]="
      + moment.utc(selectedDate).add(4, 'days').local().format('YYYY-MM-DD') + "T00:00:00", {
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        setScheduleItems(response.data.data.items)
        let _date = response.data.data.items[0].date_from
        let _index = 0
        let _events = []
        response.data.data.items.map((item, index) => {
          if (item.date_from !== _date) {
            _date = item.date_from;
            _index = 0;
          }
          _index += 1;
          if (item.production_jobs && item.production_jobs[0]) {
            item.production_jobs.map((job, index) => {
              _events.push({
                start: _date,
                end: moment.utc(_date).add(1, 'days').local().format('YYYY-MM-DD'),
                technology_name: job.production_item?.technology?.name,
                partner_name: job.partner_name,
                container: "Festőkocsi",
                status: job.status,
                quantity: job.quantity,
                resource: _index,
                original_job: job,
                original_item: item,
              })
            })
          }
        })
        setEvents(_events)
        axios({
          method: 'get',
          url: process.env.REACT_APP_API_HOST + "/api/v2/production-item/calendar",
          params: {},
          headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
            'App-Network': localStorage.getItem("networkId")
          }
        })
          .then(response => {
            let _tasks = []
            response.data.data.items.map((item, index) => {
              let max_quantity_per_job = 0
              if (item.project_item.project && item.project_item.project.max_quantity_per_job) {
                max_quantity_per_job = item.project_item.project.max_quantity_per_job
              }
              let _remainingItems = Number(item.quantity - item.quantity_in_jobs)
              let _subtasksNumber = _remainingItems / max_quantity_per_job
              if (localStorage.getItem('shceduleCalendarView') === 'subtask' && _subtasksNumber > 1 && _subtasksNumber !== Infinity) {
                _tasks.push({
                  id: item.id,
                  technology_name: item.technology_name,
                  partner_name: item.partner_name,
                  container: "Festőkocsi",
                  status: item.status,
                  quantity: _remainingItems,
                  allDay: true,
                })
                for (let i = 1; i <= Math.ceil(_subtasksNumber); i++) {
                  let _quantity = max_quantity_per_job
                  if (i == Math.ceil(_subtasksNumber)) {
                    _quantity = _remainingItems - (max_quantity_per_job * (i - 1))
                  }
                  _tasks.push({
                    id: item.id,
                    quantity: _quantity,
                    sub_task: true,
                    allDay: true,
                  })
                }
              } else {
                _tasks.push({
                  id: item.id,
                  technology_name: item.technology_name,
                  partner_name: item.partner_name,
                  container: "Festőkocsi",
                  status: item.status,
                  quantity: _remainingItems,
                  allDay: true,
                })
              }
            })
            setTasks(_tasks)
            setLoading(false);
          })
          .catch(error => {
            window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          })
      })
      .catch(error => {
        setLoading(false);
      })
    window.App.setState({rerenderScheduleitemscalendarCalendar: false})
  }, [window.App.state.rerenderScheduleitemscalendarCalendar === true])

  return (
    <div className={"machinecycle-calendar"}>
      {loading &&
        <ProgressBar mode="indeterminate" style={{height: '5px'}}></ProgressBar>
      }
      <div className={"p-grid calendar"}>
        <div className={"p-col p-position-relative"}>
          <a className={"p-button-link"}
             style={{position: 'absolute', top: '12px', right: '8px', zIndex: '9'}}
             onClick={() => {
               const div = document.getElementById("tasks");
               if (div.style.display === "none") {
                 div.style.display = "flex";
               } else {
                 div.style.display = "none";
               }
             }}>
            <i className={"pi pi-window-maximize"}></i>
          </a>
          {/*<Eventcalendar*/}
          {/*  dataTimezone="utc"*/}
          {/*  displayTimezone="Europe/Budapest"*/}
          {/*  dragToMove={false}*/}
          {/*  dragToCreate={false}*/}
          {/*  externalDrop={true}*/}
          {/*  externalDrag={true}*/}
          {/*  dragToResize={false}*/}
          {/*  eventDelete={false}*/}
          {/*  showControls={false}*/}
          {/*  clickToCreate={false}*/}
          {/*  onEventCreate={(event) => {*/}
          {/*    setTasks([])*/}
          {/*    let _date = moment.utc(event.event.start).local().format('YYYY-MM-DD')*/}
          {/*    let _index = Number(event.event.resource - 1)*/}
          {/*    const filtered = scheduleItems.filter(item => item.date_from === _date + " 00:00:00");*/}
          {/*    if (filtered && filtered[0]) {*/}
          {/*      let _resource = [filtered[_index]]*/}
          {/*      setJobData({*/}
          {/*        ...jobData,*/}
          {/*        schedule_item: _resource[0].id,*/}
          {/*        production_item: event.event.id*/}
          {/*      })*/}
          {/*      if (event.event.sub_task) {*/}
          {/*        axios.post(process.env.REACT_APP_API_HOST + "/api/v2/production-job/calendar",*/}
          {/*          {*/}
          {/*            schedule_item: _resource[0].id,*/}
          {/*            production_item: event.event.id,*/}
          {/*            quantity: event.event.quantity,*/}
          {/*          },*/}
          {/*          {*/}
          {/*            params: {},*/}
          {/*            headers: {*/}
          {/*              'Authorization': 'Bearer ' + localStorage.getItem("userToken"),*/}
          {/*              'App-Network': localStorage.getItem("networkId")*/}
          {/*            }*/}
          {/*          })*/}
          {/*          .then(response => {*/}
          {/*            window.App.toastShow('success', 'Sikeres ütemezés!', 'A feladat ütemezésre került', '');*/}
          {/*            window.App.setState({rerenderScheduleitemscalendarCalendar: true})*/}
          {/*          })*/}
          {/*          .catch(error => {*/}
          {/*            let _message = ''*/}
          {/*            Object.keys(error.response.data.data).forEach(key => {*/}
          {/*              error.response.data.data[key].forEach(value => {*/}
          {/*                _message += value + " "*/}
          {/*              });*/}
          {/*            });*/}
          {/*            window.App.customToastShow('warn', 'A művelet nem engedélyezett!', _message);*/}
          {/*            window.App.setState({rerenderScheduleitemscalendarCalendar: true})*/}
          {/*            setDialogQuantity(false)*/}
          {/*          })*/}
          {/*      } else {*/}
          {/*        setDialogQuantity(true)*/}
          {/*      }*/}
          {/*    } else {*/}
          {/*      window.App.toastShow('warn', 'Erre a napra nem ütemezhető feladat!', 'Nincs műszak beállítva.', '');*/}
          {/*      window.App.setState({rerenderScheduleitemscalendarCalendar: true})*/}
          {/*    }*/}
          {/*  }}*/}
          {/*  renderScheduleEvent={(event) => {*/}
          {/*    return (*/}
          {/*      <div className={"event"}>*/}
          {/*        <div className={"p-grid p-m-0 p-p-0"}>*/}
          {/*          <div className={"p-col-12 p-col-align-center"}>*/}
          {/*            <span className={"p-d-block p-text-bold h1"}>{event.original.technology_name}</span>*/}
          {/*          </div>*/}
          {/*          <div className={"p-col-12 p-md-8 p-col-align-center"}>*/}
          {/*            <span className={"p-d-block"} style={{fontSize: '11px'}}>{event.original.container}</span>*/}
          {/*            <span className={"p-d-block"}*/}
          {/*                  style={{fontSize: '11px'}}>{event.original.partner_name || 'Ismeretlen partner'}</span>*/}
          {/*          </div>*/}
          {/*          <div className={"p-col-12 p-md-4 p-col-align-center p-text-right"}>*/}
          {/*            <h5 className={"p-m-0 p-p-0"}>*/}
          {/*              {event.original.quantity} db*/}
          {/*            </h5>*/}
          {/*          </div>*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    )*/}
          {/*  }}*/}
          {/*  onEventClick={(event) => {*/}
          {/*    console.log(event)*/}
          {/*    if(event?.event?.original_job?.production_item?.shortcut_dto_id) {*/}
          {/*      history.push('/production/worksheet/update/' + event?.event?.original_job?.production_item?.shortcut_dto_id)*/}
          {/*    } else {*/}
          {/*      alert('Nem található munkalap.')*/}
          {/*    }*/}
          {/*  }}*/}
          {/*  themeVariant={"light"}*/}
          {/*  defaultSelectedDate={selectedDate}*/}
          {/*  selectedDate={selectedDate}*/}
          {/*  refDate={selectedDate}*/}
          {/*  responsive={{*/}
          {/*    small: {*/}
          {/*      view: {*/}
          {/*        timeline: {*/}
          {/*          type: 'day',*/}
          {/*          resolutionHorizontal: 'day',*/}
          {/*          size: 5,*/}
          {/*        }*/}
          {/*      }*/}
          {/*    },*/}
          {/*    medium: {*/}
          {/*      view: {*/}
          {/*        timeline: {*/}
          {/*          type: 'day',*/}
          {/*          resolutionHorizontal: 'day',*/}
          {/*          size: 5,*/}
          {/*          maxEventStack: 1,*/}
          {/*          rowHeight: 'equal',*/}
          {/*        }*/}
          {/*      }*/}
          {/*    },*/}
          {/*    large: {*/}
          {/*      view: {*/}
          {/*        timeline: {*/}
          {/*          type: 'day',*/}
          {/*          resolutionHorizontal: 'day',*/}
          {/*          size: 5,*/}
          {/*          maxEventStack: 1,*/}
          {/*          rowHeight: 'equal',*/}
          {/*        }*/}
          {/*      }*/}
          {/*    },*/}
          {/*    xlarge: {*/}
          {/*      view: {*/}
          {/*        timeline: {*/}
          {/*          type: 'day',*/}
          {/*          resolutionHorizontal: 'day',*/}
          {/*          size: 5,*/}
          {/*          maxEventStack: 1,*/}
          {/*          rowHeight: 'equal',*/}
          {/*        }*/}
          {/*      }*/}
          {/*    }*/}
          {/*  }}*/}
          {/*  data={events}*/}
          {/*  resources={[*/}
          {/*    {*/}
          {/*      id: 1,*/}
          {/*      name: '#1',*/}
          {/*    },*/}
          {/*    {*/}
          {/*      id: 2,*/}
          {/*      name: '#2',*/}
          {/*    },*/}
          {/*    {*/}
          {/*      id: 3,*/}
          {/*      name: '#3',*/}
          {/*    },*/}
          {/*    {*/}
          {/*      id: 4,*/}
          {/*      name: '#4',*/}
          {/*    },*/}
          {/*    {*/}
          {/*      id: 5,*/}
          {/*      name: '#5',*/}
          {/*    },*/}
          {/*    {*/}
          {/*      id: 6,*/}
          {/*      name: '#6',*/}
          {/*    },*/}
          {/*    {*/}
          {/*      id: 7,*/}
          {/*      name: '#7',*/}
          {/*    },*/}
          {/*    {*/}
          {/*      id: 8,*/}
          {/*      name: '#8',*/}
          {/*    },*/}
          {/*    {*/}
          {/*      id: 9,*/}
          {/*      name: '#9',*/}
          {/*    },*/}
          {/*    {*/}
          {/*      id: 10,*/}
          {/*      name: '#10',*/}
          {/*    },*/}
          {/*    {*/}
          {/*      id: 11,*/}
          {/*      name: '#11',*/}
          {/*    }*/}
          {/*  ]}*/}
          {/*/>*/}
        </div>
        <div className={"p-col-12 p-md-3 tasks p-p-0"} id={"tasks"}>
          <div>
            <div className={"p-grid p-mt-0 p-ml-0 p-mr-0 p-mb-1 p-p-0 "}>
              <div className={"p-col-12 p-md-6 p-col-align-center p-pl-0"}>
                <Calendar value={selectedDate}
                          disabled={loading}
                          locale={"default"}
                          className={"w-100"}
                          showIcon
                          onChange={(e) => {
                            setSelectedDate(getMondayOfCurrentWeek(e.value))
                          }}/>
              </div>
              <div className={"p-col-12 p-md-6 p-col-align-center p-text-right p-pr-0"}>
                {!localStorage.getItem('shceduleCalendarView') || localStorage.getItem('shceduleCalendarView') === 'task' ? (
                  <Button type="button"
                          icon="pi pi-table"
                          className={"p-button-warning p-mr-2"}
                          loading={loading}
                          onClick={() => {
                            localStorage.setItem('shceduleCalendarView', 'subtask')
                            window.App.setState({rerenderScheduleitemscalendarCalendar: true})
                          }}
                  />
                ) : (
                  <Button type="button"
                          icon="pi pi-list"
                          className={"p-button-warning p-mr-2"}
                          loading={loading}
                          onClick={() => {
                            localStorage.setItem('shceduleCalendarView', 'task')
                            window.App.setState({rerenderScheduleitemscalendarCalendar: true})
                          }}
                  />
                )}
                <Button type="button"
                        icon="pi pi-arrow-left"
                        className={"p-button-secondary p-mr-2"}
                        loading={loading}
                        onClick={() => {
                          setSelectedDate(moment.utc(selectedDate).add(-1, 'week').local().format('YYYY-MM-DD'))
                          window.App.setState({rerenderScheduleitemscalendarCalendar: true})
                        }}
                />
                <Button type="button"
                        icon="pi pi-arrow-right"
                        className={""}
                        loading={loading}
                        onClick={() => {
                          setSelectedDate(moment.utc(selectedDate).add(1, 'week').local().format('YYYY-MM-DD'))
                          window.App.setState({rerenderScheduleitemscalendarCalendar: true})
                        }}
                />
              </div>
            </div>
            <div className={"p-grid tasks-list"}>
              {/*<Dropcontainer>*/}
              {/*  {tasks.map((task) => (*/}
              {/*    <Task key={task.id} data={task}/>*/}
              {/*  ))}*/}
              {/*</Dropcontainer>*/}
            </div>
          </div>
        </div>
        <Dialog visible={dialogQuantity}
                style={{width: '750px'}}
                header="Mennyiség megadása"
                modal
                onHide={() => {
                  window.App.setState({rerenderScheduleitemscalendarCalendar: true})
                  setDialogQuantity(false)
                }}>
          <div className={"p-px-0"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-md-12 p-col-align-center"}>
                <div className="p-field p-fluid">
                  <label htmlFor="quiantity">Mennyiség</label>
                  <span className="p-d-block">
                      <InputText id="quiantity"
                                 onChange={(e) => {
                                   setJobData({
                                     ...jobData,
                                     quantity: e.target.value
                                   })
                                 }}
                                 value={jobData.quantity}
                      />
                    </span>
                </div>
              </div>
            </div>
            <div className={"p-grid p-mt-1"}>
              <div className={"p-col-12 p-md-6 p-xl-6"}>
              </div>
              <div className={"p-col-12 p-md-6 p-xl-6 p-text-right"}>
                <Button type="button"
                        label="Mentés"
                        icon="pi pi-check"
                        loading={loading}
                        onClick={() => {
                          axios.post(process.env.REACT_APP_API_HOST + "/api/v2/production-job/calendar",
                            jobData,
                            {
                              params: {},
                              headers: {
                                'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                                'App-Network': localStorage.getItem("networkId")
                              }
                            })
                            .then(response => {
                              setDialogQuantity(false)
                              window.App.toastShow('success', 'Sikeres ütemezés!', 'A feladat ütemezésre került', '');
                              window.App.setState({rerenderScheduleitemscalendarCalendar: true})
                            })
                            .catch(error => {
                              let _message = ''
                              Object.keys(error.response.data.data).forEach(key => {
                                error.response.data.data[key].forEach(value => {
                                  _message += value + " "
                                });
                              });
                              window.App.customToastShow('warn', 'A művelet nem engedélyezett!', _message);
                              window.App.setState({rerenderScheduleitemscalendarCalendar: true})
                              setDialogQuantity(false)
                            })
                        }}
                />
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    </div>
  )
}
export default withTranslation('common')(ScheduleitemMachinecycleCalendarComponent);
